import './AccountPages.scss'
import React, { useState, useEffect } from 'react'
import useTranslations from '@src/hooks/useTranslations'
import BEMHelper from 'react-bem-helper'
import { Formik } from 'formik'
import validator from '@src/form/validations'
import Phonenumber from '../Phonenumber'
import { useConnect } from 'redux-bundler-hook'
import FormContainer from '@src/components/FormContainer'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { get } from 'lodash'
import {
	azureGetMobileVerificationCodeNewPhonenumber,
	azureGetMobileVerificationCode,
	azureApiGatewayPost,
} from '@src/api/azureApiGateway/client'
import { googleAnalytics } from '@src/api/googleanalytics/googleAnalytics'
import { REGISTRATION_STEPS } from '@src/components/account/Account'

const bem = new BEMHelper('registration-page')

function MobileNumberVerificationPage({ setNextStep, setError, setLoading }) {
	const t = useTranslations()
	const [verificationCodeResent, setVerificationCodeResent] = useState(false)

	const { customerInfo, doRefreshCustomerInfo } = useConnect(
		'selectCustomerInfo',
		'doRefreshCustomerInfo',
	)

	const onResendCodeClicked = (phonenumber) => {
		setVerificationCodeResent(true)
		getMobileVerificationCode(phonenumber)
	}

	async function getMobileVerificationCode(phonenumber) {
		setLoading(true)
		try {
			const response =
				customerInfo.phonenumber === phonenumber
					? await azureGetMobileVerificationCode(
							customerInfo.customerId,
							phonenumber ? phonenumber : customerInfo.phonenumber,
					  )
					: await azureGetMobileVerificationCodeNewPhonenumber(
							customerInfo.customerId,
							phonenumber ? phonenumber : customerInfo.phonenumber,
					  )
			setLoading(false)
			return response
		} catch (error) {
			setError({
				message: get(error, 'response.data.messages')
					? error.response.data.messages
					: 'kinto.error.send-mobile-verification-code',
			})
			setLoading(false)
		}
	}

	const onConfirmMobilePhone = async (verificationcode) => {
		try {
			setLoading(true)
			await azureApiGatewayPost(
				`customer/${customerInfo.customerId}/verify_phonenumber`,
				{ verification_code: verificationcode },
				{ useToken: true, params: { registration: true } },
			)
			doRefreshCustomerInfo()
			setNextStep(REGISTRATION_STEPS.DRIVERS_LICENSE)
			setLoading(false)
		} catch (error) {
			setLoading(false)
			setError({
				message: get(error, 'response.data.messages')
					? error.response.data.messages
					: 'kinto.error.could-not-confirm-phonenumber',
			})
		}
	}

	useEffect(() => {
		googleAnalytics.pushVirtualPageView(
			`/virtual/account/mobilenumberverificationpage/${customerInfo.customerId}`,
			`User with userid ${customerInfo.customerId} is verifying phone number`,
		)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div {...bem('')}>
			<FormContainer>
				<Formik
					initialValues={{
						verificationcode: '',
						phonenumber: customerInfo.phonenumber || '',
					}}
					validationSchema={validator({
						verificationcode: {
							validatorKey: 'verificationCode',
							required: true,
						},
						phonenumber: { validatorKey: 'phonenumber', required: true },
					})}
				>
					{(props) => {
						const { values, touched, errors, handleChange, handleBlur } = props
						return (
							<>
								<TextField
									label={t('kinto.form.validation-code')}
									id={t('kinto.form.validation-code')}
									name='verificationcode'
									variant='outlined'
									maxLength='4'
									value={values.verificationcode}
									fullWidth
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.verificationcode && touched.verificationcode}
									helperText={
										errors.verificationcode &&
										touched.verificationcode &&
										errors.verificationcode
									}
								/>
								<Button
									aria-label={t('kinto.general.next')}
									variant='contained'
									color='primary'
									disabled={errors.verificationcode && touched.verificationcode}
									onClick={() => onConfirmMobilePhone(values.verificationcode)}
								>
									{t('kinto.general.next')}
								</Button>
								<Phonenumber {...props} />
								<div {...bem('small-info-container')}>
									<div {...bem('send-again-text')}>
										<p className='small'>
											{verificationCodeResent
												? t('kinto.register.validation-code-resent')
												: ''}
										</p>
									</div>
									<Button
										aria-label={t('kinto.register.resend-validation-code')}
										color='primary'
										size='small'
										onClick={() => onResendCodeClicked(values.phonenumber)}
									>
										{t('kinto.register.resend-validation-code')}
									</Button>
								</div>
							</>
						)
					}}
				</Formik>
			</FormContainer>
		</div>
	)
}

export default MobileNumberVerificationPage
